module.exports = __webpack_public_path__ + "img/clubhouse.23a994d5.svg";